import * as React from 'react';
import { NoNavigationPageWrapper } from '../../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { SingleColumnLayout } from '../../../designSystem/layouts/SingleColumnLayout';
import { Button } from '../../../designSystem/button/Button';
import { PageHeader } from '../../../designSystem/PageHeader';
import { CustomForm } from '../../../amorg-common';
import { useParams } from 'react-router-dom';
import { LoadingPageOverlay } from '../../../designSystem/LoadingPageOverlay';
import { getCustomFormAnonymous, getCustomFormAnswer } from '../../../api/customFormClientApi';
import { CustomFormAnswerSubmissionPanel } from '../_components/CustomFormAnswerSubmissionPanel';
import { P } from '../../../designSystem/typography/Body';
import { PublicPageProvider } from '../../_contexts/PublicPageContext';



export function CustomFormSubmitAnswerPagePublic (): JSX.Element
{
    const params = useParams<{ siteId: string, answerId: string; }>();

    const [state, setState] = React.useState<{
        loading: boolean,
        form: CustomForm,
        done: boolean;
    }>({
        loading: true,
        form: null,
        done: false
    });

    React.useEffect(() =>
    {
        const getData = async () =>
        {
            const answer = await getCustomFormAnswer(params.answerId, params.siteId);
            const form = await getCustomFormAnonymous(answer.formId, params.siteId);
            setState({ ...state, form, loading: false });
        };
        getData();
    }, [params.siteId, params.answerId]);


    return (

        <PublicPageProvider>
            <NoNavigationPageWrapper>
                <SingleColumnLayout
                    noDivider
                    contentContainer={
                        <>
                            <LoadingPageOverlay loading={state.loading} />

                            {!state.done &&
                                <>
                                    <CustomFormAnswerSubmissionPanel
                                        siteId={params.siteId} form={state.form} answerId={params.answerId} disableAnswerComponents={false} />

                                    <Button variant="filled" size='magnum' text="Afslut besvarelsen"
                                        onClick={() => setState({ ...state, done: true })} />
                                </>
                            }

                            {state.done &&
                                <EndSubmission />
                            }

                        </>
                    } />

            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}


function EndSubmission (): JSX.Element
{
    return (
        <article>
            <PageHeader headerText="Besvarelsen er afsluttet" headerStyle="secondary-gray" />
            <P verticalMargin='40px'>
                Tak for din besvarelse!<br />
                <br />
                Den er nu sendt og kan ses af din arbejdsmiljørepræsentant og CRECEAs eksperter.<br />
                Kontakt din arbejdsmiljørepræsentant, hvis du har brug for mere information.<br />
                <br />
                Du kan nu lukke siden.
            </P>
        </article>
    );
}